"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorDoc = void 0;
var ErrorDoc;
(function (ErrorDoc) {
    ErrorDoc["AuthenticationTokenErrors"] = "authentication-token-errors";
    ErrorDoc["DataSourceNoCollectionSelected"] = "data-source-no-collection-selected";
    ErrorDoc["FlowInstanceSetupFailed"] = "flow-instance-setup-failed";
    ErrorDoc["FlowInstanceSetupTimeout"] = "flow-instance-setup-timeout";
    ErrorDoc["WebhookCannotFindUser"] = "webhook-cannot-find-user";
})(ErrorDoc = exports.ErrorDoc || (exports.ErrorDoc = {}));
//# sourceMappingURL=error-doc-enum.js.map